import { HomepageHeroSection } from "@/components/homepage/hero";
import { ValuePropsSection } from "@/components/homepage/value-props";
import { TechStackSection } from "@/components/homepage/tech-stack";
import { AboutSection } from "@/components/homepage/about";
import { PortfolioSection } from "@/components/homepage/portfolio";
import { ContactSection } from "@/components/homepage/contact";
import { Page } from "@/components/layout/page";

export function Homepage() {
  return (
    <Page>
      <HomepageHeroSection />
      <ValuePropsSection />
      <AboutSection />
      <TechStackSection />
      <PortfolioSection />
      <ContactSection />
    </Page>
  );
}
